import React from 'react'

import { I18n } from '@front/volcanion'
import { ModelMenuSelectorField, TextField } from '@front/squirtle'

import { Grid } from '@mui/material'

const SendCommentForm = () =>
  <Grid container rowSpacing={1.5}>
    <Grid size={12}>
      <TextField label={I18n.t('title.label', { count: 1 })} name={'title'} disabled />
    </Grid>
    <Grid size={12}>
      <ModelMenuSelectorField
        label={I18n.t('comment.type')}
        name={'type'}
        model_name={'commenttype'}
        labelKeys={['label']}
        searchMode={'search'}
        required
        config={{
          initial_filter: { category: 'JFPNk9Qxj' },
          sort: ['display_index ASC'],
          mutator: elem => ({ ...elem, label: _.upperFirst(_.get(elem, `name_translated`)) })
        }}
      />
    </Grid>
    <Grid size={12}>
      <TextField
        label={I18n.t('message.label', { count: 1 })}
        name={'text'}
        multiline
        minRows={2}
      />
    </Grid>
  </Grid>

export default SendCommentForm
